import { Config } from '../config';
import { UserService } from './User';

export const TransferOptionsService = {
  /**
     * [LIST]
     */
  List() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.list, requestOptions);
  },
  /**
     * [DETAIL]
     */
  Detail(id) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify({ id }),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.detail, requestOptions);
  },
  /**
     * [Save]
     */
  Save(formData) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(formData),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.save, requestOptions);
  },
  /**
     * [CURRENCY_LIST]
     */
  CurrencyList() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.currencyList, requestOptions);
  },
  /**
     * [RULES]
     */
  Rules() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.rules, requestOptions);
  },
  /**
    * [DAILY_LIMIT]
    */
  DailyLimit() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.dailyLimit, requestOptions);
  },
  /**
    * [DAILY_LIMIT]
    */
  DailyLimitSave(formData) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(formData),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.dailyLimitSave, requestOptions);
  },
  /**
    * [BLACK_LIST]
    */
  BlackList() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.blackList, requestOptions);
  },
  /**
    * [BLACK_LIST_SAVE]
    */
  BlackListSave(formData) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(formData),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.blackListSave, requestOptions);
  },
  /**
    * [BLACK_LIST_EDIT]
    */
  BlackListEdit(id) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify({ id }),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.blackListEdit, requestOptions);
  },
  /**
    * [BLACK_LIST_DELETE]
    */
  BlackListDelete(id) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify({ id }),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.blackListDelete, requestOptions);
  },
  /**
    * [WHITE_LIST]
    */
  WhiteList() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.whiteList, requestOptions);
  },
  /**
  * [WHITE_LIST_DELETE]
  */
  WhiteListDelete(id) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify({ id }),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.whiteListDelete, requestOptions);
  },
  /**
* [WHITE_LIST_SAVE]
*/
  WhiteListSave(formData) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(formData),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.whiteListSave, requestOptions);
  },
  /**
 * [WHTE_LIST_EDIT]
 */
  WhiteListEdit(id) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify({ id }),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.whiteListDetail, requestOptions);
  },
  /**
    * [ROLES]
    */
  Roles() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.roles, requestOptions);
  },
  /**
    * [ROLE_EDIT]
    */
  RoleEdit(login) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify({ id: login }),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.roleEdit, requestOptions);
  },
  /**
    * [ROLE_SAVE]
    */
  RoleSave(formData) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(formData),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.roleSave, requestOptions);
  },
  /**
    * [DELETE_ROLE]
    */
  RoleDelete(login) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify({ id: login }),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.roleDelete, requestOptions);
  },
  /**
      * [TRANSFEROPTION_LIST]
      */
  TransferOptionList() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.transferOptionList, requestOptions);
  },
  /**
  * [COUNTRY_LIST]
  */
  CountryList() {
    const requestOptions = {
      method: 'Get',
      headers: Config.utilities.authorizedHeader(),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.countryList, requestOptions);
  },
  /**
   * [RULE_SAVE]
   */
  RuleSave(formData) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(formData),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.ruleSave, requestOptions);
  },
  /**
    * [GET_RULE]
    */
  GetRule(id) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(id),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.getRule, requestOptions);
  },
  /**
    * [DELETE_RULE]
    */
  DeleteRule(id) {
    const requestOptions = {
      method: 'Post',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(id),
    };

    return TransferOptionsService.Common.Fetch(Config.service.transferOptions.deleteRule, requestOptions);
  },
  /**
     * [COMMON]
     * @function Fetch
     */
  Common: {
    Fetch(url, requestOptions) {
      return fetch(url, requestOptions)
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          if (response.status === 401) {
            UserService.Logout();
            window.location.reload();
          } else {
            throw new Error();
          }
          return false;
        })
        .then(json => json)
        .catch(() => false);
    },
  },
};
